/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationDataConnectionsDriversDriverOutputDto } from './FxIdApplicationDataConnectionsDriversDriverOutputDto';
import {
    FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSON,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSONTyped,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSON,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSONTyped,
} from './FxIdApplicationDataConnectionsDriversDriverOutputDto';
import type { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
import {
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto
     */
    Success: boolean;
    /**
     * 
     * @type {FxIdApplicationDataConnectionsDriversDriverOutputDto}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto
     */
    Data: FxIdApplicationDataConnectionsDriversDriverOutputDto;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto
     */
    Error?: FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}

